'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minute;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/minute.js
// module id = 182
// module chunks = 0